import { useDispatch, useSelector } from 'react-redux';
import { setDocumentErrors, resetDocumentErrors } from '@/state/actions';
import { createSaveableObject, verifyDocumentFields } from '@/util';

/**
 * Invoice Hook
 * Validates an invoice object.
 *
 * Returns false, or clean invoice data.
 */
export const useValidateInvoice = () => {
    const dispatch = useDispatch();
    const activeBusiness = useSelector((state) => state?.user?.activeBusiness);
    const businessProfileUpdated =
        activeBusiness?.flags?.businessProfileUpdated;

    const validateInvoice = async (invoiceToValidate) => {
        const invoiceData = createSaveableObject({
            type: 'invoice',
            currentObject: invoiceToValidate,
            activeBusiness
        });

        const verifiedResult = await verifyDocumentFields(invoiceData);

        if (!businessProfileUpdated)
            verifiedResult.errors = {
                ...verifiedResult.errors,
                from: {
                    companyName: {
                        message: 'Company is required'
                    }
                }
            };

        if (!verifiedResult.success) {
            dispatch(setDocumentErrors(verifiedResult.errors));
        } else {
            dispatch(resetDocumentErrors());
        }

        if (!verifiedResult.success) {
            return false;
        }

        return invoiceData;
    };

    return validateInvoice;
};
